export type TUseSessionStorage<T> = {
  getItem: () => T | undefined;
  setItem: (value: T) => void;
  removeItem: () => void;
};

export function useSessionStorage<T>(key: string): TUseSessionStorage<T> {
  const setItem = (value: T): void => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      window.console.error(error);
    }
  };

  const getItem = (): T | undefined => {
    try {
      const item = window.sessionStorage.getItem(key);
      if (item === null) {
        return undefined;
      }
      return JSON.parse(item);
    } catch (error) {
      window.console.error(error);
      return undefined;
    }
  };

  const removeItem = (): void => {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      window.console.error(error);
    }
  };

  return {
    getItem,
    setItem,
    removeItem,
  };
}
